import React from 'react';
import PropTypes from 'prop-types';
import ConnectedScreeningHelp from './ConnectedScreeningHelp';

const ScreeningHelpRouting = ({ match }) => <ConnectedScreeningHelp />;

ScreeningHelpRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default ScreeningHelpRouting;
